import type { SVGProps } from "react";
import { ReactComponent as SGMRaw } from "./sgm-tag.svg";
import { ReactComponent as SGPRaw } from "./sgp-tag.svg";
import { ReactComponent as SRMRaw } from "./srm-tag.svg";
import { ReactComponent as SRPRaw } from "./srp-tag.svg";

type MultiIconProps = SVGProps<SVGSVGElement> & {
  isParlayLocale?: boolean;
};

export const SGMIcon = ({ isParlayLocale, ...props }: MultiIconProps) => {
  const Icon = isParlayLocale ? SGPRaw : SGMRaw;
  return <Icon {...props} />;
};

export const SRMIcon = ({ isParlayLocale, ...props }: MultiIconProps) => {
  const Icon = isParlayLocale ? SRPRaw : SRMRaw;
  return <Icon {...props} />;
};
